import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { ContainerOccupancyEmptyFullRate } from 'app/models/container-occupancy-empty-full-rate.model';
import { ContainerOccupancyReport } from 'app/models/container-occupancy-report.model';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { PoligonPoligonDetail } from 'app/models/poligon-poligonDetail.model';
import { Poligon } from 'app/models/poligon.model';
import { User } from 'app/models/user.model';
import * as L from 'leaflet';
import { ContainerService } from 'app/services/container.service';
import { DeviceService } from 'app/services/device.service';
import { ExcelService } from 'app/services/excel.service';
import { PoligonService } from 'app/services/poligon.service';
import { ReportingService } from 'app/services/reporting.service';
import { ApexChart, ApexDataLabels, ApexNonAxisChartSeries, ApexResponsive, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContainerDetailComponent } from './container-detail/container-detail.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';


export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    colors:string[];
    dataLabels:ApexDataLabels;
    legend:any
    responsive: ApexResponsive[];
    labels: any;
  };

  export class PoligonLayer{
    layer:any
    poligon:Poligon
    calc:number
  }

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class DashboardComponent implements OnInit {
    @ViewChild("FullEmptyPieChart") fullEmptyPieChart: ChartComponent;
    public fullEmptyPieChartOptions: Partial<ChartOptions>;  

    @ViewChild("ContainerOccupancyPieChart") containerOccupancyPieChart: ChartComponent;
    public containerOccupancyPieChartOptions: Partial<ChartOptions>;  


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild('sortRate') sortRate: MatSort;
    @ViewChild('paginatorU') private _paginatorU: MatPaginator;

    single: any[] = [];

    // options
    gradient: boolean = false;
    showLegend: boolean = false;
    maxLabelLength: number = 50;
    showLabels: boolean = true;
    isDoughnut: boolean = false;
    legendPosition: string = 'below';

    colorScheme = {
        domain: ['#A10A28', '#5AA454']
    };
    
    private _deviceList : Array<Device>;
    public get deviceList() : Array<Device> {
        return this._deviceList;
    }
    public set deviceList(v : Array<Device>) {
        this._deviceList = v;
    }

    private map_dashboard;
    
    public poligonLayer:Array<PoligonLayer>  =[];
    widgets: any;
    public cd25=0;
    public cd50=0;
    public cd75=0;
    public user: User;
    public poligons: Array<PoligonPoligonDetail> = [];
    public tableLoading = false;
    public selectUnloadingDevice = [];
    public selectUnloadingRateDevice = [];
    public selectPoligon: Poligon;
    public selectByFilter = "month"
    public selectByRateFilter = "month"
    public fullContainer = 0;
    public emptyContainer = 0;
    public StartTime: Date;
    public EndTime: Date
    public StartRateTime: Date;
    public EndRateTime: Date
    public fullContainerList: Array<Container> = [];
    public emptyContainerList: Array<Container> = [];
    public criticalContainerList: Array<Container> = [];
    public _containerOccupancyReport: Array<ContainerOccupancyReport>
    public _containerOccupancyReportBase: Array<ContainerOccupancyReport>
    public _containerOccupancyEmptyFullRate: Array<ContainerOccupancyEmptyFullRate>
    public _containerOccupancyEmptyFullRateBase: Array<ContainerOccupancyEmptyFullRate>
    private _polygonList: Array<Poligon> = [];
    private _greenQuarter: Array<Container> = [];
    private _redQuarter: Array<Container> = [];
    //#region  ListData
    public get polygonList(): Array<Poligon> {
        return this._polygonList;
    }
    private _containerAllList: Array<Container> = [];

    public get containerAllList(): Array<Container> {
        return this._containerAllList;
    }

    //#endregion

    private _dataSource: MatTableDataSource<ContainerOccupancyReport> = undefined;
    public get dataSource(): MatTableDataSource<ContainerOccupancyReport> {
        return this._dataSource;
    }
    private _displayedColumns = ['name', 'altitude', 'batarya', 'solarEnerjiVoltaj', 'sonBaglantiTarih',];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    private _dataSourceRate: MatTableDataSource<ContainerOccupancyEmptyFullRate> = undefined;
    public get dataSourceRate(): MatTableDataSource<ContainerOccupancyEmptyFullRate> {
        return this._dataSourceRate;
    }
    private _displayedColumnsRate = ['deviceId', 'emptyOccupancyCount', 'fullOccupancyCount', 'emptyRate', 'fullRate', 'count', 'address'];

    public get displayedColumnsRate(): Array<string> {
        return this._displayedColumnsRate;
    }

    //#region ChartProperty
    public barLabel: string[] = [];
    public chartLabel: string[] = [];
    public chartData: number[] = [];
    public chartFullEmptyLabel: string[] = [];
    public chartFullEmptyData: number[] = [];
    public barChartData: any;
    public barArray: number[] = [];
    //#endregion

    chartFilled() {
        this.chartLabel = []
        this.chartFullEmptyLabel = []
        this.chartLabel.push(this._translateService.instant("FULL_CONTAINERS"), this._translateService.instant("EMPTY_CONTAINERS"));
        this.chartFullEmptyLabel.push('50% altında', '50% üstünde')
        this.chartData.push(0, 0, 0);
        this.chartFullEmptyData = [0, 0];

        //  this.barLabel.push('Bölge');

        this.barChartData = [
            { data: [0, 0, 0], label: 'Value' },
        ];
    }

    //#region chartOptions
    public chartBarOptions = {

        tooltips: {
            display: true,
            backgroundColor: '#fff',
            titleFontSize: 14,
            titleFontColor: 'chocolate',
            bodyFontColor: '#000',
            bodyFontSize: 12,
            displayColors: false,
        },

        animation: {
            duration: 1000,
            easing: "easeInOutQuad"
        },
        responsive: true,
        legend: {
            display: true,
            position: 'top',
            cornerRadius: 10,
            titleSpacing: 4,
            footerFontStyle: 'bold',
            multiKeyBackground: '#eee'
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: false,
                }
            }],
            yAxes: [{
                display: true,
                ticks: {
                    beginAtZero: true,
                    max: 100
                },
                scaleLabel: {
                    display: false,
                },
            }]
        }
    }
    chartOptions = {

        animation: {
            duration: 500,
            easing: "easeInOutQuad"
        },

        responsive: true,
        legend: {
            display: true,
            position: "right",
            fullWidth: false,
            reverse: true
        }
    };
    public chartFullEmptyOptions = {

        animation: {
            duration: 500,
            easing: "easeInOutQuad"
        },

        responsive: true,
        legend: {
            display: true,
            position: "right",
            fullWidth: false,
            reverse: true
        }
    };
    public colors =
        [{
            backgroundColor: [
                'rgba(164,45,26,255)',
                'rgba(44,110,70,255)',
                'rgba(230,126,34,255)',
                'rgba(241,196,15,255)',
            ]
        }
        ];
    public colorsFullEmpty =
        [{
            backgroundColor: [
                'rgba(44,110,70,255)',
                'rgba(164,45,26,255)'
            ]
        }
        ];
    //#endregion

    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }
    constructor(
        private _reportingService: ReportingService,
        private _polygonService: PoligonService,
        private _dialog: MatDialog,
        private _spinner:NgxSpinnerService,
        private _deviceService:DeviceService,
        private _toasterService:ToasterService,
        private _containerService: ContainerService,
        private _translateService: TranslateService,
        public appConfigService: AppInitializationService,
        private _excelService: ExcelService
    ) {

        this.fullEmptyPieChartOptions = {
            colors: ['#A10A28', '#5AA454'],
            series: [50, 50],
            chart: {
              width: 380,
              type: "pie"
            },
          };

          this.containerOccupancyPieChartOptions = {
            colors: ['#A10A28', '#5AA454'],
            series: [50, 50],
            chart: {
              width: 380,
              type: "pie"
            },
          };

        this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.chartLanguageChange();

        });
    }
    chartLanguageChange() {
        this.chartFilled();
           this.ChartData();
           this.ContainerChartData();
    }
    private async getPolygon(): Promise<Array<PoligonPoligonDetail>> {
        try {
            this.poligons = await this._polygonService.getPoligonContainerDetail(parseInt(localStorage.getItem("CompanyID")));
            this.barLabel = [];
            this.barChartData = [];
            this.fullContainerList = [];
            this.emptyContainerList = [];
            this.ChartBarData();
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
    }

    public async ngOnInit() {
        this._spinner.show('loading')
        this.cd25 =this.appConfigService.apiConfig["container-msf-yellow"]
        this.cd50 =this.appConfigService.apiConfig["container-msf-orange"]
        this.cd75 =this.appConfigService.apiConfig["container-msf-red"]
        this.chartFilled();
        await this.getPolygon()
        await this.getAllContainerList();
        await this.onContainerUnloadingEmptyFullRateClick("month");
        await this.initMap();
        this.updateTableDataSource()
        this.updateTableDataSourceRate()
        this.onContainerUnloadingStatusClick("month");
        this.chartLanguageChange();
        this._spinner.hide('loading')
    }

    private async initMap(): Promise<void> {
        this.map_dashboard = L.map('map-dashboard', {
            center: [39.09766, 34.56039],
            zoom: 6
        });

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map_dashboard);
        navigator.geolocation.getCurrentPosition(
             (position)=> {
                let lat = position.coords.latitude;
                let long = position.coords.longitude;
                this.map_dashboard.setView(new L.LatLng(lat, long), 13)

            },(error)=>{
                this._toasterService.toastFail(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"))
            }
        );

        await this.drawPoligons();
        this.poligonLayer.forEach((poligon)=>{
            poligon.layer.on('mouseover', (e)=> {
                this.setHighlight(poligon);
              });
            
              poligon.layer.on('mouseout', (e)=> {
                this.clearHighlight(poligon);
              });
        })
    }

    setHighlight(poligon:PoligonLayer){
        poligon.layer.setStyle({opacity: 0.8})
    }
    
    clearHighlight(poligon:PoligonLayer){
        poligon.layer.setStyle({opacity: 0.3})
    }

    async drawPoligons() {
        this.poligons.forEach(i => {
            if (i.poligonDetailContainerDevice.length > 0) {
                var totalMSF = 0;
                 i.poligonDetailContainerDevice.forEach(e => {
                     if (e.device && e.device.deviceLatestStatus) {
                         var calc = (
                            ((parseInt(e.container.altitude) - parseInt(e.container.deadZone)) - (parseInt(e.device.deviceLatestStatus.mesafe) - parseInt(e.container.deadZone)))
                             * 100 / (parseInt(e.container.altitude) - parseInt(e.container.deadZone)))
                         if (calc < 0) {
                             calc = 0;
                         }
                         else if (calc > 100) {
                             calc = 100;
                         }

                         totalMSF += e.device.deviceLatestStatus ? calc : 0;
                     }
                 })
                var calculate = i.poligonDetailContainerDevice.length != 0 ? Math.round((totalMSF / i.poligonDetailContainerDevice.length)) : 0;

                var poligonList = new Array();
                let points = i.points.split("*");
                points.forEach((y:any) => {
                    var location = y.split([","]);
                    poligonList.push(new L.LatLng(location[0], location[1]));
                });

                if(calculate<i.treshold){
                    var firstpolyline = new L.polygon(poligonList, {
                        color: 'rgba(44,110,70,255)',
                        weight: 3,
                        opacity: 0.3,
                        smoothFactor: 1
                    });
                    var html=`<span style='display:block;'>${this._translateService.instant('REGION')} = ${i.name}</span>`
                    html+=`<span style='display:block;'>${this._translateService.instant('CONTAINER_COLLECTION_THRESHOLD')} = ${i.treshold}</span>`
                    html+=`<span style='display:block;'>${this._translateService.instant('AVERAGE_OCCUPANCY')} = ${calculate}%</span>`
                    firstpolyline.bindTooltip(html);
                   
                    var pl = new PoligonLayer();
                    pl.layer =firstpolyline;
                    pl.poligon = i;
                    pl.calc = calculate;
                    this.poligonLayer.push(pl);

                    this.map_dashboard.addLayer(firstpolyline);
                }
                else{
                    var firstpolyline = new L.polygon(poligonList, {
                        color: 'rgba(164,45,26,255)',
                        weight: 3,
                        opacity: 0.3,
                        smoothFactor: 1
                    });
                    var html=`<span style='display:block;'>${this._translateService.instant('REGION')} = ${i.name}</span>`
                    html+=`<span style='display:block;'>${this._translateService.instant('CONTAINER_COLLECTION_THRESHOLD')} = ${i.treshold}</span>`
                    html+=`<span style='display:block;'>${this._translateService.instant('AVERAGE_OCCUPANCY')} = ${calculate}%</span>`
                    firstpolyline.bindTooltip(html);

                    var pl = new PoligonLayer();
                    pl.layer =firstpolyline;
                    pl.poligon = i;
                    pl.calc = calculate;

                    this.poligonLayer.push(pl);
                    this.map_dashboard.addLayer(firstpolyline);
                }
   
            }
        })
    }

    public openContainerDetailDialog(containers) {
        const dialog = this._dialog.open(ContainerDetailComponent, {
            data: containers,
            width:'1400px',
            maxHeight:'90vh'
        })

        dialog.componentInstance.done.subscribe(() => {
            dialog.close();
        })
    }


    public onUnloadingDeviceSelect() {
        if (this.selectUnloadingDevice.length == 0) {
            this._containerOccupancyReport = this._containerOccupancyReportBase;
            this.updateTableDataSource();
        } else {
            this._containerOccupancyReport = this._containerOccupancyReportBase.filter(x => this.selectUnloadingDevice.indexOf(x.deviceId) != -1)
            this.updateTableDataSource();
        }
    }

    public async onUnloadingRateSelect() {
        if (this.selectUnloadingRateDevice.length == 0) {
            this._containerOccupancyEmptyFullRate = this._containerOccupancyEmptyFullRateBase;
            await this.calculateContainerUnloadingEmptyFullRate();
            await this.updateTableDataSourceRate();
        } else {
            this._containerOccupancyEmptyFullRate = this._containerOccupancyEmptyFullRateBase.filter(x => this.selectUnloadingRateDevice.indexOf(x.deviceId) != -1)
            await this.calculateContainerUnloadingEmptyFullRate();
            await this.updateTableDataSourceRate();
        }
    }


    public onContainerUnloadingStatusClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 1);
                this.getContainerUnloadingStatus(start, end)
                break;
            case "week":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 7);
                this.getContainerUnloadingStatus(start, end)

                break;
            case "month":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 30);
                this.getContainerUnloadingStatus(start, end)
                break;

            default:
                this.getContainerUnloadingStatus(startTime, endTime)
                break;
        }

    }

    public onContainerUnloadingEmptyFullRateClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 1);
                this.getContainerUnloadingEmptyFullRate(start, end)
                break;
            case "week":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 7);
                this.getContainerUnloadingEmptyFullRate(start, end)

                break;
            case "month":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 30);
                this.getContainerUnloadingEmptyFullRate(start, end)
                break;

            default:
                this.getContainerUnloadingEmptyFullRate(startTime, endTime)
                break;
        }

    }
    public getContainerUnloadingEmptyFullRate(startTime?: Date, endTime?: Date) {
        try {
            this._reportingService.getContainerUnloadingEmptyFullRate(parseInt(localStorage.getItem("CompanyID")), startTime, endTime).then(response => {
                this._containerOccupancyEmptyFullRate = response;
                this._containerOccupancyEmptyFullRateBase = response;
                this.calculateContainerUnloadingEmptyFullRate();
                this.onUnloadingRateSelect()
            })
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
    }

    public calculateContainerUnloadingEmptyFullRate() {
        var empty = 0;
        var full = 0;
        var count = 0;
        this._containerOccupancyEmptyFullRate.forEach(x => {
            empty += x.emptyOccupancyCount;
            full += x.fullOccupancyCount;
            count += x.count;
        })
        var data1 = ((empty * 100) / count).toFixed(2);
        var data2 = ((full * 100) / count).toFixed(2);
        
        this.fullEmptyPieChartOptions = {
            colors: ['#A10A28', '#5AA454'],
            series: [parseFloat(data1), parseFloat(data2)],
            chart: {
              width: 380,
              type: "pie"
            },
            labels: ["Verimsiz Toplama", "İdeal Toplama"],
            legend: {
                fontWeight: 600,
                labels: {
                  useSeriesColors: true,
                },
              },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };

        this.single = [{ name: "Verimsiz Toplama", value: data1 }, { name: "İdeal Toplama", value: data2 }]
        this.chartFullEmptyData = [parseFloat(data1), parseFloat(data2)]
    }


    private async updateTableDataSourceRate(): Promise<void> {
        this._dataSourceRate = new MatTableDataSource<ContainerOccupancyEmptyFullRate>(this._containerOccupancyEmptyFullRate);
        this._dataSourceRate.paginator = this._paginatorU;
        this._dataSourceRate.sort = this.sortRate;
    }


    // public async onReportClick() {
    //     const columns = ["No", "Cihaz id", "Tarih", "Haberleşme Sayısı", "Boşaltılmadan Önce", "Boşaltıldıktan Sonra", "Adres"];
    //     let idx = 1;
    //     const dataset = this._containerOccupancyReport.map(p => {
    //         return {
    //             index: idx++,
    //             cihazId: `${p.deviceId}`,
    //             tarih: `${p.date}`,
    //             adet: `${p.containerName}`,
    //             dolulukOnce: `${p.beforeOccupancy}`,
    //             dolulukSonra: `${p.afterOccupancy}`,
    //             Address: `${p.address}`,

    //         }
    //     });
    //     this._excelService.exportAsExcelFile(
    //         columns,
    //         dataset,
    //         'Çöp Boşaltım Raporu',
    //         "",
    //         new Date(),
    //         {
    //             worksheetName: 'Çöp Boşaltım Raporu'
    //         }
    //     );
    // }

    // public async onReportRateClick() {
    //     const columns = ["No", "Cihaz id", "50% Altında Toplanan", "50% Üstünde Toplanan", "50% Altında ki Oran ", "50% Üstünde ki Oran", 'Toplam Toplanan', "Adres"];
    //     let idx = 1;
    //     const dataset = this._containerOccupancyEmptyFullRate.map(p => {
    //         return {
    //             index: idx++,
    //             cihazId: `${p.deviceId}`,
    //             emptyCount: `${p.emptyOccupancyCount}`,
    //             fullCount: `${p.fullOccupancyCount}`,
    //             emptyRate: `${p.emptyRate}`,
    //             fullRate: `${p.fullRate}`,
    //             count: `${p.count}`,
    //             Address: `${p.address}`,

    //         }
    //     });
    //     this._excelService.exportAsExcelFile(
    //         columns,
    //         dataset,
    //         'Çöp Boşaltım Oran Raporu',
    //         "",
    //         new Date(),
    //         {
    //             worksheetName: 'Çöp Boşaltım Oran Raporu'
    //         }
    //     );
    // }

    public getContainerUnloadingStatus(startTime?: Date, endTime?: Date) {
        try {
            this.tableLoading = true;
            this._reportingService.getContainerUnloadingStatus(parseInt(localStorage.getItem("CompanyID")), startTime, endTime).then(response => {
                this._containerOccupancyReport = response;
                this._containerOccupancyReportBase = response;
                this.onUnloadingDeviceSelect();
                this.tableLoading = false;
            })
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Container>(this._containerAllList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    //#region  ChartData
    private ChartBarData() {
        this.poligons.forEach(i => {
            if (i.poligonDetailContainerDevice.length > 0) {
                this.barLabel.push(i.name);
                var totalMSF = 0;
                 i.poligonDetailContainerDevice.forEach(e => {
                     if (e.device && e.device.deviceLatestStatus) {
                         var calc = (
                            ((parseInt(e.container.altitude) - parseInt(e.container.deadZone)) - (parseInt(e.device.deviceLatestStatus.mesafe) - parseInt(e.container.deadZone)))
                             * 100 / (parseInt(e.container.altitude) - parseInt(e.container.deadZone)))
                         if (calc < 0) {
                             calc = 0;
                         }
                         else if (calc > 100) {
                             calc = 100;
                         }

                         totalMSF += e.device.deviceLatestStatus ? calc : 0;
                     }
                 })
                var calculate = i.poligonDetailContainerDevice.filter(x=>x.container.rootType=='container').length != 0 ? Math.round((totalMSF / i.poligonDetailContainerDevice.filter(x=>x.container.rootType=='container').length)) : 0;
                this.barArray.push(calculate)
                this.ChartData();
            }
        })
    }

    private ChartData() {
        this.barChartData = [
            { data: this.barArray, label: this._translateService.instant('OCCUPANCY') + " (%)" },
        ];
    }

    private ContainerChartData() {
        this.containerOccupancyPieChartOptions = {
            colors: ['rgba(164, 45, 26, 255)', 'rgba(44, 110, 70, 255)'],
            series: [this._redQuarter.length,this._greenQuarter.length],
            chart: {
              width: '100%',
              height:'300px',   
              type: "pie"
            },
            dataLabels:{
                enabled: true,
                style: {
                    fontSize: '14px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 'bold',
                    colors: ['#FFF']
                },
            },
            labels: [this._translateService.instant("FULL_CONTAINERS"), this._translateService.instant("EMPTY_CONTAINERS")],
            legend: {
                fontWeight: 600,
                labels: {
                  useSeriesColors: true,
                },
              },
          };
    }

    private ContainerChartCalculate(){
        this._redQuarter = []
        this._greenQuarter = [];
        this.containerAllList.forEach(x=>{
            if(x.device!=null && x.device.deviceLatestStatus!=null){
                var calc = (((parseInt(x.altitude) - parseInt(x.deadZone)) - (parseInt(x.device.deviceLatestStatus.mesafe) - parseInt(x.deadZone)))
                 * 100 / (parseInt(x.altitude) - parseInt(x.deadZone)))
                if (calc < 0) {
                    calc = 0;
                }
                else if (calc > 100) {
                    calc = 100;
                }

                var poligonByContainerId = this.poligons.find(p=>p.poligonDetailContainerDevice.find(y=>y.container.id===x.id))
                
                if(poligonByContainerId){
                    if (poligonByContainerId.treshold > calc) {
                        var empty = new Container();
                        empty.device = x.device;
                        empty = x;
                        this.emptyContainerList.push(empty);
                        this.emptyContainer++;
                        this._greenQuarter.push(x)
                    }
                    else {
                        var full = new Container();
                        full.device = x.device;
                        full = x;
                        this.fullContainerList.push(full);
                        this._redQuarter.push(x)
                        this.fullContainer++;
                    }
                }
                else{
                    if (50 > calc) {
                        var empty = new Container();
                        empty.device = x.device;
                        empty = x;
                        this._greenQuarter.push(x)
                        this.emptyContainerList.push(empty);
                        this.emptyContainer++;
                    }
                    else {
                        var full = new Container();
                        full.device = x.device;
                        full = x;
                        this.fullContainerList.push(full);
                        this._redQuarter.push(x)
                        this.fullContainer++;
                    }
                }
                
            }
            else{
                var empty = new Container();
                empty.device = x.device;
                empty = x;
                this.emptyContainerList.push(empty);
                this.emptyContainer++;
                this._greenQuarter.push(x)
            }
        })
        this.ContainerChartData()
    }
    //#endregion

    private async getAllContainerList(): Promise<void> {
        try {
            this._containerAllList = await (await this._containerService.getAllContainerDetail(parseInt(localStorage.getItem("CompanyID")))).filter(x => x.containerType != true);
            this.updateTableDataSource()
            this.ContainerChartCalculate();
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }
}
